import { CurrencyEnum } from '@systemeio/ui'
import { useDigitalProduct } from 'modules/digital-product/hooks/use-digital-product'
import PricePlans from 'modules/digital-product/price-plans'
import { PricePlanType } from '@systemeio/types'
import { usePaymentMethods } from 'modules/payment-methods/hooks/use-payment-methods'
import React, { FC } from 'react'
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description'
import { Loader } from 'shared/components/loader'
import { SectionMessage } from 'shared/components/section-message'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

type Props = {
  pricePlans: PricePlanType[]
  onChange: (pricePlans: PricePlanType[]) => void
  currency?: CurrencyEnum
  errors: string[]
  digitalProductId?: number | null
}

export const PricePlanItem: FC<Props> = ({
  pricePlans,
  onChange,
  currency,
  errors,
  digitalProductId,
}) => {
  const { t } = useLocoTranslation()
  const { data: paymentMethodsData } = usePaymentMethods(currency)

  const { mutate } = useDigitalProduct(digitalProductId)

  const mutatePricePlans = async (pricePlans: PricePlanType[]) => {
    await mutate(data => data && { ...data, pricePlans }, false)
  }

  if (!currency) {
    return (
      <div className={'flex flex-col items-center gap-1'}>
        <SectionMessage className={'w-full'}>
          {t('dashboard.store.product.choose_currency')}
        </SectionMessage>
        <FieldErrorAndDescription error={errors.join(', ')} />
      </div>
    )
  }

  if (!paymentMethodsData) {
    return <Loader />
  }

  return (
    <PricePlans
      errors={errors}
      currency={currency}
      paymentMethods={paymentMethodsData.paymentMethods}
      maxPricePlans={Infinity}
      pricePlans={pricePlans}
      onChanePricePlans={onChange}
      mutatePricePlans={mutatePricePlans}
    />
  )
}
